import { useAppData } from "../../contexts/AppDataContext";
import StubPage from "../../pages/StubPage";

// UX-GAP-01 §1.9/§1.10: Revenue Extras (`loyalty`) and Retail (`retail`) are module-gated —
// Sidebar.jsx already hides their nav item when the module is off, but a direct URL visit must
// ALSO render nothing real ("completely absent (not greyed out)", not merely hidden from nav).
export function ModuleGate({ module, title, children }) {
  const { entitlements } = useAppData();
  if (entitlements[module] === false) {
    return <StubPage title={`${title} isn't enabled for your organization`} />;
  }
  return children;
}
